import { takeLatest, put } from 'redux-saga/effects';

import {
  ASK_SHOW_SUBSCRIPTION_EXPIRED,
  SUBSCRIPTION_EXPIRED_CLOSE_MODAL,
} from '../../actions/subscriptionExpired/constants';
import {
  hideSubscriptionExpiredModal,
  showSubscriptionExpiredModal,
  setNextActionExpired,
} from '../../actions/subscriptionExpired';

export function* askModal(request) {
  const {
    payload: { nextActionExpired },
  } = request;
  yield put(setNextActionExpired(nextActionExpired));
  yield put(showSubscriptionExpiredModal());
}

export function* closeSubscriptionExpiredModal() {
  yield put(setNextActionExpired(null));
  yield put(hideSubscriptionExpiredModal());
}

export default function* subscriptionExpiredSaga() {
  yield takeLatest(ASK_SHOW_SUBSCRIPTION_EXPIRED, askModal);
  yield takeLatest(
    SUBSCRIPTION_EXPIRED_CLOSE_MODAL,
    closeSubscriptionExpiredModal
  );
}
